<div class="header" [ngClass]="{'header--expandable': isExpandable, 'header--expanded': isExpanded}" (click)="isExpanded = !isExpanded">
    <div class="header_expander">
        <i class="fas" [ngClass]="{'fa-caret-right': isExpandable && !isExpanded, 'fa-caret-down': isExpanded, 'fa-circle': !isExpandable}"></i>
    </div>
    <div class="header_title">{{title}}</div>
    <div class="header_total">
        <input type="{{inputType}}" class="header_input" (click)="cancelEvent($event)" [ngClass]="{'header_input--read-only': !isEditable}" [formControl]="totalControl">
    </div>
</div>

<div class="content" *ngIf="isExpanded">
    <ng-content></ng-content>
</div>